import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "contact",
  "use": "contact-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"contact\"><path fill=\"currentColor\" d=\"M0 1.08v17.1h4.14v4.74l9.47-4.74H24V1.08zm22.07 15.17h-8.92l-7.08 3.54v-3.54H1.93V3h20.14z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol